import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class NewTabIcon extends BaseIcon {
  getChildren = () => [
    <path d="M10.4 14H4.6C3.2 14 2 12.8 2 11.4V6.6C2 5.2 3.2 4 4.6 4H6v2H4.6c-.3 0-.6.3-.6.6v4.8c0 .3.3.6.6.6h5.8c.3 0 .6-.3.6-.6V9h2v2.4c0 1.4-1.2 2.6-2.6 2.6z" fill={this.getColor()} />,
    <path fillRule="evenodd" clipRule="evenodd" fill={this.getColor()} d="M13 7V4.3L8.8 8.4 7.4 7l4.1-4H9V2h5v5z"/>
    ]
  getViewBox = () => '0 0 16 16'
}
